export default __webpack_public_path__ + "static/media/stethoscope.530aa483.png";